'use client';

import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getInfinitySearchArticles } from '@/features/articles';
import { Topic } from '.';

interface TopicBySearchProps {
  search: string;
}

export const TopicBySearch = ({ search }: TopicBySearchProps) => {
  const {
    isFetching,
    data: infinityArticles,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteQuery(
    getInfinitySearchArticles({
      search,
      key: 'articles',
      limit: 15,
    })
  );

  const articles = useMemo(() => {
    return infinityArticles?.pages.flatMap((page) => page.articles) ?? [];
  }, [infinityArticles]);

  return (
    <Topic
      title={`Результаты поиска ${search ? `«${search}»` : ''}`}
      articles={articles}
      onFetchMore={fetchNextPage}
      isFetching={isFetching}
      hasNextPage={hasNextPage}
      highlight={search}
    />
  );
};
